var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3455_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5039 22.8477L48.5183 17.0082C46.9953 12.4805 44.2039 8.4879 40.4774 5.50734C36.751 2.52678 32.2472 0.684284 27.5039 0.199951V22.8477Z",
    fill: "#256BE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.911 31.3016C24.6016 31.3894 24.2815 31.4338 23.96 31.4336C23.0153 31.4336 22.1094 31.0576 21.4414 30.3882C20.7735 29.7188 20.3982 28.8109 20.3982 27.8642V0.833252C15.7685 1.70941 11.4833 3.88811 8.04357 7.11469C4.6038 10.3413 2.15157 14.4824 0.973527 19.0541C-0.204517 23.6257 -0.0596975 28.4389 1.39105 32.9311C2.8418 37.4233 5.53854 41.4089 9.16604 44.4219C12.7935 47.435 17.2019 49.351 21.8759 49.946C26.5498 50.541 31.2962 49.7905 35.5603 47.7821C39.8243 45.7737 43.4298 42.5905 45.9553 38.6045C48.4808 34.6185 49.8219 29.9945 49.8219 25.2729C49.8219 24.9766 49.8219 24.6839 49.797 24.3876L24.911 31.3016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3455_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.950daabb14c16e908e5c9a6021ada035.svg";
export { ForwardRef as ReactComponent };